/**
 * intl-latam-ec-portal-documents
 * No description
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Información del PEP si el campo isPep es verdadero.
 */
export class PersonFormPepModel { 
    /**
     * Cargo para Ecuador, descripción para Colombia.
     */
    charge?: string;
    /**
     * Fecha de ingreso, aplica solo Colombia.
     */
    dateEntry?: any;
    /**
     * Fecha de desvinculación, aplica solo Colombia.
     */
    dateUnlinked?: any;
    /**
     * Función pep, aplica solo Ecuador.
     */
    functionPep?: string;
    /**
     * Nivel jerarquico pep, aplica solo Ecuador.
     */
    hierarchicalLevel?: string;

    constructor(){
        this.dateEntry= null;
        this.dateUnlinked= null;
    }
}
